import {DceJsx, DceJsxRenderer} from "dce-jsx";
import {Editor} from "@tiptap/core";
import {Transaction, NodeSelection} from "prosemirror-state";
import ICONS from "../../assets/ICONS";
import {ToolbarItem} from "../ToolbarItem";

export class ImageFloatItem extends ToolbarItem {

    private editor: Editor;

    private currentIcon: HTMLElement;

    //'left', 'right', 'none', 'block-center', 'block-left', 'block-right'
    private floats: [string, string][] = [

        ["left", ICONS.imageFloatLeft],
        ["right", ICONS.imageFloatRight],
        ["none", ICONS.imageFloatNone],
        ["block-left", ICONS.imageBlockLeft],
        ["block-center", ICONS.imageBlockCenter],
        ["block-right", ICONS.imageBlockRight]

    ]

    public mount(editor: Editor): void {
        this.editor = editor;
    }


    bindByRef(ref: string, elem: HTMLElement) {
        if(ref == 'current-icon'){
            this.currentIcon = elem;
        }
    }

    public consumeTransaction(editor: Editor, transaction: Transaction): void{
        console.log("Image Item transaction");

        let node = ImageFloatItem.getImgeNodeSelection(transaction);

        if(null == node){
            this.root.classList.add('disabled');
            this.root.classList.remove('opened');
            this.currentIcon.innerHTML = ICONS.imageFloatNone;
        }else{
            this.root.classList.remove('disabled');

            let attrs = node.node.attrs as any;

            console.log("NODE", node);
            console.log("FLOAT", attrs['float']);

            let icon = ICONS.imageFloatNone;

            for(let a of this.floats){
                if(a[0] == attrs['float']){
                    icon = a[1];
                    break;
                }
            }

            this.currentIcon.innerHTML = icon;

        }

    }

    private static getImgeNodeSelection(transaction: Transaction): NodeSelection{
        let tsel = transaction.selection;

        if(tsel instanceof NodeSelection){

            let sel = tsel as NodeSelection;
            if(sel.node.type.name == 'image'){
                console.log("SELECTED IMAGE!", sel);



                return sel;
            }
        }
        return null;
    }

    public click(){
        //open menu
        console.log("CLICK OPEN BUTTON");

        if(!this.root.classList.contains('disabled')) {
            if(!this.root.classList.contains('opened')) {
                this.root.classList.add('opened');
            }else{
                this.root.classList.remove('opened');
            }
        }

    }

    public clickItem(e: any){
        console.log('33333333333333333333333clicked', e);

        let event = e as MouseEvent;
        let elem = event.target as HTMLElement;

        while(elem.tagName != 'BUTTON' && elem.parentElement != null){
            elem = elem.parentElement;
        }

        let float = elem.dataset['float'];

        let selected = this.editor.state.selection.from;
        let selectedTo = this.editor.state.selection.to;

        console.log("SSSSSSSSSSSSSSSSSSSS" , this.editor.state.selection);

        //@ts-ignore
        this.editor.chain().focus()
            .setImageFloat(float)
            .setNodeSelection(selected)
            .run();


    }

    render(): JSX.Element {


        return (
            <button type="button" onClick={() => this.click()} className={"btn dropdown disabled"}>
                <i ref={"current-icon"} dangerouslySetInnerHTML={{__html: ICONS.imageFloatNone}}></i>

                <div className={"options horizontal"}>
                    {
                        this.floats.map(i => {
                            return (
                                <button type="button" data-float={i[0]} onClick={(e) => this.clickItem(e)} dangerouslySetInnerHTML={ {__html: i[1]} }></button>
                            )
                        })
                    }
                </div>
            </button>
        )
    }

}

